import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ColorLogo from "../assets/login/ColorLogo.png";
import logo1 from "../assets/header/HABD.png";
import logo2 from "../assets/login/DMW_Patiala.png";

const DownloadRulesPDF = async (
  selectedSiteName,
  trainDetails,
  rules = [],
  setIsLoading
) => {
  try {
    setIsLoading(true);
    const trainId = trainDetails?.TrainId || "N/A";

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.username || "Guest";
    const downloadDate = new Date();
    const formattedDateTime = `${downloadDate.toLocaleDateString()} ${downloadDate.toLocaleTimeString()}`;

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const logoWidth = 18;
    const logoHeight = 15;

    const addHeader = () => {
      doc.setTextColor(0, 0, 0);

      if (ColorLogo) {
        const logoX = 10;
        const logoY = 5;
        const logoW = 35;
        const logoH = logoHeight;
        doc.addImage(ColorLogo, "PNG", logoX, logoY, logoW, logoH);
      }

      if (logo2) {
        doc.addImage(
          logo2,
          "PNG",
          pageWidth - logoWidth - 10,
          5,
          logoWidth,
          logoHeight
        );
      }

      const titleText = "NOVIUS HABD (Lite) - ALARM & WARNING RULES REPORT";
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");

      const textWidth = doc.getTextWidth(titleText);
      const centerX = pageWidth / 2;
      const textX = centerX - textWidth / 2;

      if (logo1) {
        const logo1X = textX - logoWidth - 4;
        doc.addImage(logo1, "PNG", logo1X, 5, logoWidth, logoHeight);
      }

      doc.text(titleText, textX, 15);
      doc.setDrawColor(200, 200, 200);
      doc.line(10, 22, pageWidth - 10, 22);
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const pageStr = `Page ${i} of ${pageCount}`;
        doc.text(
          pageStr,
          pageWidth - 14 - doc.getTextWidth(pageStr),
          pageHeight - 10
        );

        doc.setTextColor(80);
        doc.setFont("helvetica", "italic");
        const footerText = `Downloaded by: ${userName} | Download Time: ${formattedDateTime}`;
        doc.text(footerText, 14, pageHeight - 10);
      }
    };

    const formatPdfDate = (trainId) => {
      if (!trainId) return "N/A";
      const parts = trainId.split("_");
      if (parts.length >= 6) {
        return `${parts[2]}/${parts[1]}/${parts[0]} ${parts[3]}:${parts[4]}`;
      }
      return trainId;
    };

    const formatRangePdf = (min, max) => {
      if (min === null || max === null) {
        if (min === null && max === null) return "N/A";
        return `${min ?? max} °C`;
      }
      if (min === max) return `${min} °C`;
      return `${min} - ${max} °C`;
    };

    addHeader();

    let lastTableY = 35;

    // Rules Table
    doc.setFontSize(12);
    doc.text("Applied Alarm & Warning Rules", 14, lastTableY);
    lastTableY += 8;

    const ruleColumns = [
      { content: "Coach Type", styles: { halign: "center" } },
      { content: "Temp Range", styles: { halign: "center" } },
      { content: "Diff Range", styles: { halign: "center" } },
      { content: "Alarm Type", styles: { halign: "center" } },
    ];

    const ruleBody = rules.map((rule) => [
      { content: rule.TypeOfBogi || "Standard" },
      { content: formatRangePdf(rule.MinTemp, rule.MaxTemp) },
      { content: formatRangePdf(rule.MinDiff, rule.MaxDiff) },
      {
        content: !rule.SeverityColor ? 'Safe' : (
          rule.SeverityColor.toLowerCase() === 'red' ? 'Alarm' : (
            (rule.SeverityColor.toLowerCase() === 'yellow' || rule.SeverityColor.toLowerCase() === 'orange') ? 'Warning' : 'Match'
          )
        )
      },
    ]);

    autoTable(doc, {
      startY: lastTableY,
      margin: { left: 10, right: 10 },
      head: [ruleColumns],
      body: ruleBody,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 3,
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        halign: "center",
        valign: "middle",
      },
      headStyles: {
        fillColor: [173, 216, 230], // Light Blue
        textColor: [0, 0, 0], // Black text as requested
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      }
    });

    addFooter();

    const fileName = `Rules_Report_${trainId}.pdf`;
    doc.save(fileName);
  } catch (error) {
    console.error("Error generating Rules PDF:", error);
    alert(`Failed to generate Rules PDF: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

export default DownloadRulesPDF;
